import { receiptUrl } from './resources.js'
import common from './common.js'

//
//
//
async function sendReceiptToEmailByOrderId(payload) {
    let url = `${receiptUrl}`;
    let data = {
        orderId : payload.orderId,
        email : payload.email
    };

    return await common.postData(url, data);
}

export default {
    name: 'receiptService',
    sendReceiptToEmailByOrderId,
}